//Authentication
import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import MainLayout from "../Hoc/MainLayout";
import SnackBar from "../components/SnackBar";
import Login from "../containers/login";
import SecureStorage from "./SecureStorage";
import Dash from "../containers/dash";
import jwt_decode from "jwt-decode";
import { checkUser } from "../actions/loginActions";
import { connect } from "react-redux";
import { messageBox } from "../actions/notificationAction";

// Sample accessioning panel
import LimsAdminDash from "../containers/LimsAdmin-agent";
import LimsAdminHome from "../LimsAdmin-Panel/components/Home/home"
import LimsAdminFilterPage from "../LimsAdmin-Panel/pages/filter";
import LimsAdminOfflineFilterPage from "../LimsAdmin-Panel/pages/offlineFilter";
import LimsAdminReceivedTicketPage from "../LimsAdmin-Panel/pages/receivedTicket";
import LimsAdminSampleCollection from "../LimsAdmin-Panel/pages/SampleCollection/index";
import LimsAdminBooking from "../LimsAdmin-Panel/components/Bookings/NewBooking/index";
import LimsAdminViewBooking from "../LimsAdmin-Panel/components/Bookings/ViewBooking/index";
import LimsAdminBillPdf from "../LimsAdmin-Panel/components/BillPdf/index";
import LimsAdminShahbazkarBillPdf from "../LimsAdmin-Panel/components/BillPdf/shahbazkarBill";
import LimsAdminViewOfflineBooking from "../LimsAdmin-Panel/components/Bookings/ViewBooking/offlineView";
import LimsAdminEditBookingForm from "../LimsAdmin-Panel/components/Bookings/EditBookingForm/EditBookingForm";
import LimsAdminDownload from "../LimsAdmin-Panel/components/Bookings/DownloadBooking/Trf";
import SAComplaintsBooking from "../LimsAdmin-Panel/tables/queryTicketsBooking";
import SampleAccCenterInfo from "../LimsAdmin-Panel/tables/centerTable";
import SAInbox from "../LimsAdmin-Panel/components/notificationInbox/index";
import SampleAccSampleHandOver from "../LimsAdmin-Panel/tables/sampleHandOverTable";
import SampleAccSampleHandOver2 from "../LimsAdmin-Panel/tables/sampleHandoverOld";
import LimsAdminTestPackages from "../LimsAdmin-Panel/pages/testPackages";
import SampleUnregisterBooking from "../LimsAdmin-Panel/tables/unregisterdBooking";
import LimsAdminHIV from "../LimsAdmin-Panel/components/Bookings/ViewBooking/Hivreport";
import SABiomarkerScreening from "../LimsAdmin-Panel/components/Bookings/ViewBooking/BiomarkerScreeningreport";
import LimsAdminPhaRiderCashDue from "../LimsAdmin-Panel/pages/PhleboRiderDue";
// import LimsAdminHelpDesk from "../LimsAdmin-Panel/pages/HelpDesk";
import LimsAdminReportNotDeliverd from "../LimsAdmin-Panel/pages/ConsolidateReportBooking/filter";
// import SampleAccessingUploadTrf from "../LimsAdmin-Panel/components/Bookings/ViewBooking/trfUpload";
import SampleAccessingExportBookings from "../LimsAdmin-Panel/pages/ExportBookings/exportBooking";
// import LimsAdminhistoryform from "../LimsAdmin-Panel/components/Bookings/ViewBooking/ViewHistoryform";
import LimsAdminNbsForm from "../LimsAdmin-Panel/components/Bookings/ViewBooking/ViewNbsForm";
import LimsAdminAnalyticsDashboard from '../LimsAdmin-Panel/pages/AnalyticsData';
import LimsAdminNbsReport from "../LimsAdmin-Panel/components/Report/nbsReport";
import LimsAdminNiptReport from "../LimsAdmin-Panel/components/Report/Nipt/Report1copy";
import LimsAdminBrcaReport from "../LimsAdmin-Panel/components/Report/BrcaReport/brcaReport";
import LimsAllergyReport from "../LimsAdmin-Panel/components/Report/AllergyReport/alergy";
import LimsAdminGenerateReport from "../LimsAdmin-Panel/pages/generateReport";
import LimsCreatereport from "../LimsAdmin-Panel/pages/filter";
import LimsAdminNbsReportData from "../LimsAdmin-Panel/components/Report/nbsReport/index";
import LimsAdminCustomerReport from "../LimsAdmin-Panel/pages/customerReport";
import LimsAdminUploadReport from "../LimsAdmin-Panel/pages/Upload_Report/uploadReport";
import LimsAdminBCRAblReport from "../LimsAdmin-Panel/components/Report/BCRABL/index";
import LimsAdminHLAReport from "../LimsAdmin-Panel/components/Report/HlaTyping/index";
import LimsAdminJAKReport from "../LimsAdmin-Panel/components/Report/Jak2/index";
import LimsAdminPMLReport from "../LimsAdmin-Panel/components/Report/PmlRara/index";
import LimsAdminMCCReport from "../LimsAdmin-Panel/components/Report/MccReport/index";
import LimsAdminBcrQuantative from "../LimsAdmin-Panel/components/Report/BCRABL/brcQuantative";
import LimsAdminQfPcr from "../LimsAdmin-Panel/components/Report/Qf_Pcr/index";
import LimsAdminCma315 from "../LimsAdmin-Panel/components/Report/Cma315/index";
import LimsAdminSangerSequencing from "../LimsAdmin-Panel/components/Report/SangerSequencing/index";
import LimsAdminHbb from "../LimsAdmin-Panel/components/Report/HbbReport/index";
import LimsAdminCma750 from "../LimsAdmin-Panel/components/Report/Cma750/index";
import LimsAdminDnaExtraction from "../LimsAdmin-Panel/components/Report/DnaExtraction/index";
import LimsAdminSmnMlpa from "../LimsAdmin-Panel/components/Report/SmnMlpa/index";
import LimsAdminDmdMlpa from "../LimsAdmin-Panel/components/Report/DmdMlpa/index";
import LimsIrmaabl1 from "../LimsAdmin-Panel/components/Report/IRMA ABL/IRMA ABL1 postive";
import LimsFactorV from "../LimsAdmin-Panel/components/Report/FactorReport/factorV";
import LimsFactorII from "../LimsAdmin-Panel/components/Report/FactorReport/factorII";
import LimsPapSmear from "../LimsAdmin-Panel/components/Report/PapSmear/index";
import MEN1GeneSequencing from "../LimsAdmin-Panel/components/Report/MEN1GeneSequencing";

function AuthenticatedRoutes(props) {
  if (window) {
    var path = window.location.pathname;
    var query = window.location.search;
  }
  const token = SecureStorage.getItem("token");
  console.log(token, "token")
  // const decoded = decode(token);
  if (token) {
    return (
      <Routes>
        <Route
          path="/"
          element={<Dash path={path} query={query} />}
        />
      </Routes>)
  } else {
    return <Route render={() => <Navigate to="/" />} />;
  }
}

const HasRole = ({ children, role }) => {
  const token = SecureStorage.getItem("token");
  if (!token) {
    window.location = "/";
  }
  const decoded = jwt_decode(token);
  if (decoded.user_group !== role) {
    window.location = "/dashboard";
  } else {
    return children;
  }
  return <div>Redirecting....</div>;
}

function AppRoutes(props) {

  return (
    <BrowserRouter>
      <MainLayout>
        <SnackBar />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="dashboard"
            element={<AuthenticatedRoutes />}
          />
          <Route
            path="dashboard/la/*"
            element={
              <HasRole role="LimsAdmin">
                <LimsAdminDash>
                  <Routes>
                    {/* <Route
                      path="/"
                      element={<LimsAdminHome />}
                    /> */}
                    {/* <Route
                      path="booking_list"
                      element={<LimsAdminFilterPage />}
                    /> */}
                    <Route
                      path="offline_bookings"
                      element={
                        <LimsAdminOfflineFilterPage />
                      }
                    />
                    <Route
                      path="received_ticket"
                      element={
                        <LimsAdminReceivedTicketPage />
                      }
                    />
                    <Route
                      path="booking-view/:id"
                      element={<LimsAdminViewBooking />}
                    />
                    <Route
                      path="cc_bill_pdf/:id"
                      element={<LimsAdminBillPdf />}
                    />
                    <Route
                      path="shahbazker_bill_pdf/:id"
                      element={<LimsAdminShahbazkarBillPdf />}
                    />
                    <Route
                      path="offline-booking-view/:id"
                      element={
                        <LimsAdminViewOfflineBooking />
                      }
                    />
                    <Route
                      path="booking"
                      element={<LimsAdminBooking />}
                    />
                    <Route
                      path="sample_collection"
                      element={
                        <LimsAdminSampleCollection />
                      }
                    />

                    <Route
                      path="booking-edit/:id/edit"
                      element={
                        <LimsAdminEditBookingForm />
                      }
                    />
                    <Route
                      path="download/:id/download"
                      element={<LimsAdminDownload />}
                    />
                    <Route
                      path="sampleaccessiong-hiv/:id"
                      element={<LimsAdminHIV />}
                    />
                    <Route
                      path="sampleaccessiong-BiomarkerScreeningreport/:id"
                      element={<SABiomarkerScreening />}
                    />
                    {/* <Route
                      path="historyform/:id"
                      element={<LimsAdminhistoryform />}
                    /> */}
                    <Route
                      path="nbsform/:id"
                      element={<LimsAdminNbsForm />}
                    />
                    <Route
                      path="booking/tickets"
                      element={<SAComplaintsBooking />}
                    />
                    <Route
                      path="centerInfo"
                      element={<SampleAccCenterInfo />}
                    />
                    <Route
                      path="inbox"
                      element={<SAInbox />}
                    />
                    <Route
                      path="SampleHandOver"
                      element={<SampleAccSampleHandOver />}
                    />
                    <Route
                      path="SampleHandOverold"
                      element={<SampleAccSampleHandOver2 />}
                    />
                    <Route
                      path="testPackages"
                      element={<LimsAdminTestPackages />}
                    />
                    <Route
                      path="unregister-booking"
                      element={<SampleUnregisterBooking />}
                    />
                    <Route
                      path="cash-due-on-pha-rider"
                      element={
                        <LimsAdminPhaRiderCashDue />
                      }
                    />
                    <Route
                      path="report_not_deliverd"
                      element={
                        <LimsAdminReportNotDeliverd />
                      }
                    />
                    {/* <Route
                      path="uploadTrf/:id"
                      element={<SampleAccessingUploadTrf />}
                    /> */}
                    <Route
                      path="export-bookings"
                      element={<SampleAccessingExportBookings />}
                    />

                    {/* <Route
                      path="helpdesk"
                      element={<LimsAdminHelpDesk />}
                    /> */}
                    <Route
                      path="analytics_data"
                      element={<LimsAdminAnalyticsDashboard />}
                    />
                    <Route
                      path="report/:id"
                      element={<LimsAdminNbsReport />}
                    />
                    <Route
                      path="nipt-report/:firstP/:secondP/:thirdP"
                      element={<LimsAdminNiptReport />}
                    />
                    <Route
                      path="brca-report/:firstP/:secondP/:thirdP"
                      element={<LimsAdminBrcaReport />}
                    />
                    <Route
                      path="nsp-report/:firstP/:secondP/:thirdP"
                      element={<LimsAdminNbsReportData />}
                    />
                    <Route
                      path="generateReport"
                      element={<LimsAdminGenerateReport />}
                    />
                    <Route
                      path="upload_report/:firstP/:secondP"
                      element={<LimsAdminUploadReport />}
                    />
                    <Route
                      path="allergy-report/:firstP/:secondP/:thirdP"
                      element={<LimsAllergyReport />}
                    />
                    <Route
                      path="abl-report/:firstP/:secondP/:thirdP"
                      element={<LimsAdminBCRAblReport />}
                    />

                    <Route
                      path="hla-report/:firstP/:secondP/:thirdP"
                      element={<LimsAdminHLAReport />}
                    />

                    <Route
                      path="jak-report/:firstP/:secondP/:thirdP"
                      element={<LimsAdminJAKReport />}
                    />

                    <Route
                      path="pml-report/:firstP/:secondP/:thirdP"
                      element={<LimsAdminPMLReport />}
                    />
                    <Route
                      path="mcc-report/:firstP/:secondP/:thirdP"
                      element={<LimsAdminMCCReport />}
                    />
                    <Route
                      path="bcrq-report/:firstP/:secondP/:thirdP"
                      element={<LimsAdminBcrQuantative />}
                    />
                    <Route
                      path="qfpcr-report/:firstP/:secondP/:thirdP"
                      element={<LimsAdminQfPcr />}
                    />
                    <Route
                      path="cma315-report/:firstP/:secondP/:thirdP"
                      element={<LimsAdminCma315 />}
                    />
                    <Route
                      path="sangersequencing-report/:firstP/:secondP/:thirdP"
                      element={<LimsAdminSangerSequencing />}
                    />
                    <Route
                      path="men1-gene-sequencing/:firstP/:secondP/:thirdP"
                      element={<MEN1GeneSequencing />}
                    />
                    <Route
                      path="hbb-report/:firstP/:secondP/:thirdP"
                      element={<LimsAdminHbb />}
                    />
                    <Route
                      path="cma750-report/:firstP/:secondP/:thirdP"
                      element={<LimsAdminCma750 />}
                    />
                    <Route
                      path="dna-report/:firstP/:secondP/:thirdP"
                      element={<LimsAdminDnaExtraction />}
                    />
                    <Route
                      path="smnmlpa-report/:firstP/:secondP/:thirdP"
                      element={<LimsAdminSmnMlpa />}
                    />
                    <Route
                      path="dmdmlpa-report/:firstP/:secondP/:thirdP"
                      element={<LimsAdminDmdMlpa />}
                    />
                    <Route
                      path="irma-report/:firstP/:secondP/:thirdP"
                      element={<LimsIrmaabl1 />}
                    />
                    <Route
                      path="factorv-report/:firstP/:secondP/:thirdP"
                      element={<LimsFactorV />}
                    />
                    <Route
                      path="factorII-report/:firstP/:secondP/:thirdP"
                      element={<LimsFactorII />}
                    />

                    <Route
                      path="pap-smear-report/:firstP/:secondP/:thirdP"
                      element={<LimsPapSmear/>}
                      />
                    {/* <Route
                     path="/"
                     element={<LimsCreatereport/>}
                    /> */}
                    <Route
                      path="/"
                      element={<LimsAdminCustomerReport />}
                    />
                  </Routes>
                </LimsAdminDash>
              </HasRole>
            } />
        </Routes>
        {/* <Modal /> */}
        {/* <SecondModal /> */}
      </MainLayout>
    </BrowserRouter>
  );
}
export default connect(null, { checkUser, messageBox })(AppRoutes);